import { DEMO_ENTITY } from '../catalogs/banks.js';
import { z } from 'zod';
import { AgentSettingsSchema, DEMO_AGENT_SETTINGS } from '../agents/llm.js';
import { TenantCodeSchema } from '../common/tenant.js';
import { DEMO_LENDER_PROFILE, LenderProfileSchema } from './lender.js';
import { DEMO_DECISION_POLICY, DEMO_DELINQUENCY_POLICY, DEMO_ORIGINATION_POLICY, DecisionPolicySchema, DelinquencyPolicySchema, OriginationPolicySchema, } from '../origination/policies.js';
import { DEMO_FUNDING_CONFIG, FundingConfigSchema } from '../payments/config.js';
/**
 * Adaptador seleccionado por puerto (`tenant.integrations`). Los módulos de dominio dependen de
 * puertos; `services/api/src/modules/integration` elige el adaptador con esta configuración.
 */
export const TenantIntegrationsSchema = z
    .object({
    creditCore: z.enum(['paguz', 'bank', 'mock']),
    depositCore: z.enum(['sandbox', 'bank', 'mock']),
    breb: z.enum(['sandbox', 'participant-gateway', 'mock']),
    bureau: z.enum(['sandbox', 'datacredito', 'transunion', 'mock']),
    kyc: z.enum(['sandbox', 'provider', 'mock']),
    esign: z.enum(['sandbox', 'provider', 'mock']),
    notification: z.enum(['in-app', 'tenant-provider', 'mock']),
    speech: z.enum(['azure-speech', 'browser', 'mock']),
    llm: z.enum(['foundry', 'anthropic', 'openai', 'simulated']),
    blobStorage: z.enum(['azure-blob', 'memory']),
})
    .meta({ id: 'TenantIntegrations' });
export const TenantThemeSchema = z.object({
    brandName: z.string(),
    primary: z.string().regex(/^#[0-9A-Fa-f]{6}$/),
    accent: z.string().regex(/^#[0-9A-Fa-f]{6}$/),
    logoUrl: z.string().nullable(),
});
export const TenantFlagsSchema = z.object({
    DEMO_MODE: z.boolean(),
    VOICE_ENABLED: z.boolean(),
});
/** `identity.tenants.settings` (jsonb). */
export const TenantSettingsSchema = z
    .object({
    displayName: z.string(),
    participantCode: z.string(),
    theme: TenantThemeSchema,
    flags: TenantFlagsSchema,
    funding: FundingConfigSchema,
    decisionPolicy: DecisionPolicySchema,
    originationPolicy: OriginationPolicySchema,
    delinquencyPolicy: DelinquencyPolicySchema,
    agents: AgentSettingsSchema,
    /** Identificación legal de la entidad (extractos y comprobantes). Opcional en tenants antiguos. */
    lender: LenderProfileSchema.optional(),
})
    .meta({ id: 'TenantSettings' });
export const TenantSchema = z.object({
    id: z.uuid(),
    code: TenantCodeSchema,
    name: z.string(),
    status: z.enum(['ACTIVE', 'SUSPENDED']),
    settings: TenantSettingsSchema,
    integrations: TenantIntegrationsSchema,
});
/** Tenant del demo (`03-demo/02-datos-semilla.md` §1). */
export const DEMO_TENANT_CODE = 'paguz-demo';
export const DEMO_TENANT_SETTINGS = {
    displayName: `Paguz · Demo ${DEMO_ENTITY.name}`,
    participantCode: DEMO_ENTITY.participantCode,
    theme: { brandName: 'Paguz', primary: '#00306A', accent: '#6C4EF2', logoUrl: null },
    flags: { DEMO_MODE: true, VOICE_ENABLED: true },
    funding: DEMO_FUNDING_CONFIG,
    decisionPolicy: DEMO_DECISION_POLICY,
    originationPolicy: DEMO_ORIGINATION_POLICY,
    delinquencyPolicy: DEMO_DELINQUENCY_POLICY,
    agents: DEMO_AGENT_SETTINGS,
    lender: DEMO_LENDER_PROFILE,
};
export const DEMO_TENANT_INTEGRATIONS = {
    creditCore: 'paguz',
    depositCore: 'sandbox',
    breb: 'sandbox',
    bureau: 'sandbox',
    kyc: 'sandbox',
    esign: 'sandbox',
    notification: 'in-app',
    speech: 'azure-speech',
    llm: 'foundry',
    blobStorage: 'azure-blob',
};
//# sourceMappingURL=tenant.js.map